import {
  SHIPMENTMETHOD_LOADING,
  GET_SHIPMENTMETHOD,
  GET_SHIPMENTMETHOD_SUCCESS,
  GET_SHIPMENTMETHOD_FAIL,
  ADD_SHIPMENTMETHOD_SUCCESS,
  ADD_SHIPMENTMETHOD_FAIL,
  DELETE_SHIPMENTMETHOD_SUCCESS,
  DELETE_SHIPMENTMETHOD_FAIL,
  UPDATE_SHIPMENTMETHOD_SUCCESS,
  UPDATE_SHIPMENTMETHOD_FAIL,
  SHIPMENTMETHOD_RESET
} from "./actionType";

const INIT_STATE = {
  shipmentMethods: [],
  error: {},
};

const ShipmentMethod = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SHIPMENTMETHOD_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SHIPMENTMETHOD:
          return {
            ...state,
            shipmentMethods: action.payload.data,
            isShipmentMethodCreated: false,
            isShipmentMethodSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_SHIPMENTMETHOD_FAIL:
      switch (action.payload.actionType) {
        case GET_SHIPMENTMETHOD_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isShipmentMethodCreated: false,
            isShipmentMethodSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_SHIPMENTMETHOD: {
      return {
        ...state,
        isShipmentMethodCreated: false,
        loading: true,
      };
    }

    case SHIPMENTMETHOD_LOADING: {
      return {
        ...state,
        isShipmentMethodCreated: false,
        loading: true,
      };
    }

    case ADD_SHIPMENTMETHOD_SUCCESS:
      return {
        ...state,
        isShipmentMethodCreated: true,
        loading: false,
        shipmentMethods: [action.payload.data, ...state.shipmentMethods],
      };

    case ADD_SHIPMENTMETHOD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_SHIPMENTMETHOD_SUCCESS:
      return {
        ...state,
        loading: false,
        isShipmentMethodCreated: true,
        shipmentMethods: state.shipmentMethods.filter(
          shipmentMethod => shipmentMethod.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_SHIPMENTMETHOD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_SHIPMENTMETHOD_SUCCESS:
      return {
        ...state,
        loading: false,
        isShipmentMethodCreated: true,
        shipmentMethods: state.shipmentMethods.map(shipmentMethod =>
          shipmentMethod.id.toString() === action.payload.data.id.toString() ? { ...shipmentMethod, ...action.payload.data } : shipmentMethod
        ),
      };

    case UPDATE_SHIPMENTMETHOD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SHIPMENTMETHOD_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default ShipmentMethod;